var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-pad"},[_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.item[_vm.property]),expression:"item[property]"}],ref:"input",attrs:{"name":_vm.property,"type":"text"},domProps:{"value":(_vm.item[_vm.property])},on:{"click":function($event){return _vm.setCurrentInputPad(
              {
                item: _vm.item,
                property: _vm.property,
                element: $event.target,
                maxLength: _vm.maxLength ? _vm.maxLength : 20,
                alphabetable: _vm.alphabetable,
                usingDecimal: _vm.usingDecimal
              })},"focus":_vm.onFocus,"input":function($event){if($event.target.composing)return;_vm.$set(_vm.item, _vm.property, $event.target.value)}}},'input',_vm.getAttributes,false)),(_vm.error)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }